<template>
  <div id="layout">
    <!-- <PageHeader> </PageHeader> -->
    <IndexHeader> </IndexHeader>
    <!-- <router-view /> -->
    <keep-alive :include="['xinxigongkai', 'NewsCategory', 'NewsDetail']">
      <router-view />
    </keep-alive>
    <PageFooter> </PageFooter>
    <FixedLeft> </FixedLeft>
    <FixedRight> </FixedRight>
  </div>
</template>
<script>
export default {
  name: "Layout",
  components: {},
};
</script>

<style lang="scss"></style>
